import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useEffect, useState } from 'react';
import { usePopper } from 'react-popper';
import { useClickOutside } from '../../hooks/index.js';
import { BKJMenu } from '../BKJMenu/index.js';
import { getDesignLibraryElementNode } from '../BKJSelect/utils/getDesignLibraryElementNode.js';
import { Portal } from '../Portal/Portal.js';
import { useBKJEllipsisMenuUIStateContext } from './BKJEllipsisMenu.context.js';
export const BKJEllipsisMenuDropdown = ({ triggerRef, children, }) => {
    const { closeMenu } = useBKJEllipsisMenuUIStateContext();
    const [dropdownRef, setDropdownRef] = useState(null);
    const [targetElement, setTargetElement] = useState(getDesignLibraryElementNode('dropdown-root'));
    const { styles, attributes } = usePopper(triggerRef.current, dropdownRef, {
        placement: 'bottom-start',
        modifiers: [{}],
    });
    useEffect(() => {
        if (!targetElement) {
            const element = document.createElement('div');
            element.setAttribute('id', 'dropdown-root');
            document.body.prepend(element);
            setTargetElement(element);
        }
    }, []); // eslint-disable-line
    useClickOutside([dropdownRef], closeMenu, false);
    return (_jsx(Fragment, { children: targetElement && (_jsx(Portal, { targetElement: targetElement, children: _jsx(BKJMenu, { closeMenu: closeMenu, isMenuOpen: true, ref: setDropdownRef, ...attributes['popper'], css: { width: '100%', minWidth: '1000px' }, style: styles['popper'], children: children }) })) }));
};
//# sourceMappingURL=BKJEllipsisMenuDropdown.js.map